import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Header.css';

const Header = () => (
  <div className="app__header app__wrapper section__padding" id="home">
    <div className="app__wrapper_info">
      <SubHeading title="Choose the most beautiful" />
      <h1 className="app__header-h1">A Restaurant for real pleasure</h1>
      <p className="p__opensans" style={{ margin: '2rem 0' }}>The oriental restaurant will give you pleasure in selected dishes prepared in a traditional way and based on the principles of healthy eating. </p>
      <button type="button" className="custom__button">Explore Menu</button>
    </div>

    <div className="misal_img">
      <img src={images.misal2} alt="misal" />
    </div>

    {/* <div className="app__wrapper_img">
      <img src={images.oriental_food_4} alt="oriental_food" />
    </div> */}
  </div>
);

export default Header;
